module.exports = __webpack_public_path__ + "img/bj_lc_img_ch.1e39316a.gif";